import apiClient from '@u/apiClient'

export default {
  updateAccountingDiaryChiftAccountingLink(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .put(`accounting-diary/${payload.id}/partners/chift-accounting`, {
          enabled: payload.enabled
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
